import React from 'react'
import ManageOrgInvite from 'src/app/ManageOrgInvite/ManageOrgInvite'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { manageOrgInviteRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const ManageOrgInviteAppRoute: AppRoute = {
  id: AppLocation.ManageOrgInvite,
  routeProps: manageOrgInviteRouteProps,
  component: <ManageOrgInvite />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default ManageOrgInviteAppRoute
